import Vue from 'vue';
import store from '@/core/store';

import Router from 'vue-router';
import VRApp from '@/launcher/components/VRApp';

import DashboardIndexScene from '@/dashboard/DashboardIndexScene';

// Connected
// this right here is probably the will of God
import CancelLaunchRoute from '@/launcher/components/routes/VR/CancelLaunchRoute';
import GamesSearchRoute from '@/launcher/components/routes/VR/GamesSearchRoute';
import GamesIndexRoute from '@/launcher/components/routes/VR/GamesIndexRoute';
import GamesShowRoute from '@/launcher/components/routes/VR/GamesShowRoute';
import LanguageRoute from '@/launcher/components/routes/VR/LanguageRoute';
import OverlayRoute from '@/launcher/components/routes/VR/OverlayRoute';
import ReviewRoute from '@/launcher/components/routes/VR/ReviewRoute';
import ThanksRoute from '@/launcher/components/routes/VR/ThanksRoute';

import LauncherOutlet from '@/launcher/components/routes/VR/outlet/LauncherOutlet';

import authRoutes from '@/core/shared/auth/auth-routes';

Vue.use(Router);

const transformRoutesForSlicing = routes =>
  routes.map(route => {
    const { name, path, children } = route;
    const prefixedName = `vr:${name}`;
    return {
      ...route,
      name: prefixedName,
      path,
      meta: {
        ...route.meta,
        realName: name,
        isSliced: true,
      },
      children: children && transformRoutesForSlicing(children),
    };
  });
// const transformCommonRoutes = routes =>
//   routes.map(route => {
//     const { name, children } = route;
//     return {
//       ...route,
//       meta: {
//         realName: name,
//       },
//       children: children && transformCommonRoutes(children),
//     };
//   });

const commonRoutes = [
  {
    component: LauncherOutlet,
    path: '',
    name: 'index',
    children: [
      {
        path: 'games',
        name: 'games-index',
        component: GamesIndexRoute,
      },
      {
        path: 'games/search',
        name: 'games-search',
        component: GamesSearchRoute,
      },
      {
        path: 'games/:gameId',
        name: 'games-show',
        props: true,
        component: GamesShowRoute,
      },
    ],
  },
  {
    path: 'games/:gameId/cancel',
    name: 'games-confirm-cancel',
    props: true,
    component: CancelLaunchRoute,
  },
  {
    path: 'overlay',
    name: 'overlay',
    meta: {
      outlet: 'overlay',
    },
    component: OverlayRoute,
  },
  {
    path: 'review',
    name: 'review',
    component: ReviewRoute,
  },
  {
    name: 'languages',
    path: 'languages',
    component: LanguageRoute,
  },
  {
    name: 'thanks',
    path: 'thanks',
    component: ThanksRoute,
  },
  // {
  //   path: 'switchplayer',
  //   name: 'switchplayer',
  //   component: SwitchPlayerScene,
  // },
  // {
  //   name: 'signup',
  //   path: 'account/signup',
  //   props: () => ({
  //     signup: true,
  //   }),
  //   component: AccountScene,
  // },
  // {
  //   name: 'signin',
  //   path: 'account/signin',
  //   props: () => ({
  //     signin: true,
  //   }),
  //   component: AccountScene,
  // },
  // {
  //   name: 'terms',
  //   path: 'terms',
  //   component: TermsScene,
  // },
];

// Here we extend vue-router to handle slicing scene
class LauncherRouter extends Router {
  push (...args) {
    const location = args[0];
    const { name } = location;
    if (name) {
      const { debug, interopVersion } = this.currentRoute.query || {};
      const { stationId } = this.currentRoute.params || {};
      const route = super.resolve({
        ...location,
        name:
          this.currentRoute.meta.isSliced && name.slice(0, 3) !== 'vr:'
            ? `vr:${name}`
            : name,
      }).route;
      const newRoute = {
        ...location,
        params: {
          stationId,
          ...location.params,
        },
        query: {
          debug,
          interopVersion,
          ...location.query,
        },
      };
      if (!route || !this.currentRoute.meta.isSliced) {
        super.push(newRoute);
        return;
      }
      super.push({
        ...newRoute,
        name: this.currentRoute.meta.isSliced
          ? `vr:${route.meta.realName}`
          : route.meta.realName,
      });
    } else {
      super.push(...args);
    }
  }

  goBack (fallback) {
    if (store.state.launcher.previousRoute) {
      this.go(-1);
    } else {
      this.push(fallback);
    }
  }
}
const router = new LauncherRouter({
  mode: 'history',
  routes: [
    {
      component: () => import('@/videoreel/AppVideoReel'),
      name: 'videoreel',
      props: true,
      path: '/:stationId?/videoreel',
    },
    {
      component: () => import('@/launcher/AppLauncher'),
      path: '/:stationId?/launcher',
      name: 'launcher:index',
      children: [
        {
          path: 'vr',
          component: VRApp,
          children: transformRoutesForSlicing(commonRoutes),
        },
        // ...transformCommonRoutes(commonRoutes), // for remote app in the future
      ],
    },
    {
      component: { render: h => h() },
      path: '/:stationId/login',
      name: 'station-login',
      beforeEnter: async (to, from, next) => {
        const { stationId } = to.params;
        store.dispatch('updateStationLocally', {
          id: stationId,
        });
        next({
          name: 'vr:games-index',
          params: {
            stationId,
          },
        });
      },
    },
  ],
});
if (window.sbvrenv.NODE_ENV !== 'production') {
  router.addRoutes([
    // This is a test route and will be removed before merged into master
    {
      name: 'soundboard',
      path: '/soundboard',
      component: () => import('@/core/sounds/Soundboard'),
    },
    {
      component: () => import('@/dashboard/AppDashboard'),
      path: '/',
      redirect: { name: 'dashboard:index' },
      children: [
        ...authRoutes,
        {
          path: 'home',
          name: 'dashboard:index',
          component: DashboardIndexScene,
        },
      ],
    },
  ]);
}

router.afterEach((to, from) => {
  const { name, params, path, query } = from;
  store.dispatch('storePreviousRoute', {
    name,
    params,
    path,
    query,
  });
});

export default router;
